module.exports = __webpack_public_path__ + "media/images/presta_busc/presta_ico-7279c869683036845effb3c22318d7a4.svg";